import React from 'react';

import { Users } from '../..';
import { Navigation } from '../../../utils/navigation';
import { USER_ROLES } from '../../../constants/constants';

export const ENT_Admins = (props) => (
  <Users title='Enterprise Admin' Navigation={Navigation()} addNewBtnTitle='Add New Admin'
   managedRole='Admin' {...props} />
);
